@import '../../../../../../../../constants/spacing.module.less';
@import '../../../new-lineup-plan-grid-shared-styles.module.less';

@row-divider-box-shadow: inset 0 -1px 0 0 var(--grey-300);

.feature-cell {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: @space-8 @space-16;
  box-shadow: @row-divider-box-shadow;

  &.hide-row-divider {
    box-shadow: none;
  }

  &.is-last-row-in-section {
    padding-bottom: @space-32;
  }

  &.is-current-plan-column {
    background-color: @current-column-background-color;
  }

  &.is-selected-plan-column {
    background-color: @selected-column-background-color;
    box-shadow: @selected-left-box-shadow, @selected-right-box-shadow, @row-divider-box-shadow;

    &.hide-row-divider {
      box-shadow: @selected-left-box-shadow, @selected-right-box-shadow;
    }

    &.is-last-row-in-column {
      border-radius: 0 0 4px 4px;
      box-shadow: @selected-left-box-shadow, @selected-right-box-shadow, @selected-bottom-box-shadow;
    }
  }
}
